/* PurvaCreation UI behaviours: scroll reveal + sticky mobile add-to-cart. */
(function () {
  'use strict';
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function reveal() {
    var els = document.querySelectorAll('.pc-reveal:not(.is-in)');
    if (!els.length) return;
    if (reduce || !('IntersectionObserver' in window)) {
      els.forEach(function (e) { e.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    els.forEach(function (e) { io.observe(e); });
  }

  function stickyAtc() {
    var bar = document.querySelector('.pc-atc');
    if (!bar) return;
    var anchor = document.querySelector('product-form-component, .product-form, [class*="product-form"]');
    function toggle() {
      if (!anchor) { bar.classList.add('is-on'); return; }
      var r = anchor.getBoundingClientRect();
      bar.classList.toggle('is-on', r.bottom < 0 || r.top > window.innerHeight);
    }
    toggle();
    window.addEventListener('scroll', toggle, { passive: true });
    window.addEventListener('resize', toggle, { passive: true });
  }

  function init() { reveal(); stickyAtc(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
